class GaiaSlides {
	constructor() {
		jQuery(document).ready(function($) {
            // Slide Estudios
            var estudiosSlider = new Swiper('.studios-slider', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    nextEl: '#estudios .swiper-button-next',
                    prevEl: '#estudios .swiper-button-prev',
                },
            });
            
			// Slide Relatos
            var relatosSlider = new Swiper('.relatos-slider', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    nextEl: '#relatos .swiper-button-next',
                    prevEl: '#relatos .swiper-button-prev',
                },
            });

			// Slide Sobre
            var sobreSlider = new Swiper('.sobre-slider', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    nextEl: '#sobre-page-slide .swiper-button-next',
                    prevEl: '#sobre-page-slide .swiper-button-prev',
                },
            });
            var galeriaSlider = new Swiper('.galeria-slider', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                // autoplay: {
                //     delay: 5000,
                // },
                navigation: {
                    nextEl: '#galeria-gaia .swiper-button-next',
                    prevEl: '#galeria-gaia .swiper-button-prev',
                },
            });
		});
	}
}

export default GaiaSlides